<template>
  <form action="" @submit.prevent="submitForm">
    <!--    <button type="button" @click.prevent.stop="mailPass(savedUser)">mail this user their credentials</button>-->
    <!--    id: {{this.savedUser.id}}-->
    <!--    {{this.savedUser.id ? 'edit' : 'create'}}-->
    <!--    {{user.role}}-->
    <!--    <pre>{{savedUser}}</pre>-->
    <!--    <pre class="text-white">-->
    <!--      {{savedUser}}-->
    <!--    </pre>-->
    <!--    <template v-for="t in savedUser.teams">-->
    <!--      <span class="d-block">{{t.Title}}</span>-->
    <!--    </template>-->
    <div class="row">

      <div :class="type === 'register' ? 'col-xl-12' : 'col-xl-12'">
        <div class="header d-flex align-items-baseline">
          <h2>{{savedUser.fullname}}</h2>

        </div>
        <nav class="tabnav tab-nav mb-0">

          <button
            :class="(tab === 0 ? 'active' : '') + ((personalErrors.length > 0) ? 'error text-danger' : '')"
            type="button"
            @click.stop.prevent="setTab(0)"
            class=" btn-link btn tab-link">
            {{ $t('message.personal') }}
          </button>

          <button
            :class="(tab === 3 ? 'active' : '') + ((contactErrors.length > 0) ? 'error text-danger' : '')"
            type="button"
            v-if="type === 'user' || user.role.name === 'HR'" @click.stop.prevent="setTab(3)"
            class=" btn-link btn tab-link">
            {{ $t('message.contact') }}
          </button>

          <button
            :class="(tab === 1 ? 'active' : '') + ((professionalErrors.length > 0) ? 'error text-danger' : '')"
            type="button"
            v-if="type !== 'user'" @click.stop.prevent="setTab(1)"
            class="  btn-link btn tab-link">
            {{ $t('message.professional') }}
          </button>

          <button
            :class="(tab === 2 ? 'active' : '') + ((accountErrors.length > 0) ? 'error text-danger' : '')"
            type="button"
            @click.stop.prevent="setTab(2)"
            class=" btn-link btn tab-link">
            {{ $t('message.account') }}
          </button>
          <button v-if="user.role.name==='HR'&& type !== 'user'" :class="tab === 6 ? 'active' : ''"
                  type="button"
                  @click.stop.prevent="setTab(6)"
                  class=" btn-link btn tab-link">
            {{ $t('message.teams') }}
          </button>
          <button v-if="user.role.name==='HR'&& type !== 'user'" :class="tab === 4 ? 'active' : ''"
                  type="button"
                  @click.stop.prevent="setTab(4)"
                  class=" btn-link btn tab-link">
            {{ $t('message.tags') }}
          </button>
          <button v-if="user.role.name==='HR'&& type !== 'user'" :class="tab === 5 ? 'active' : ''"
                  type="button"
                  @click.stop.prevent="setTab(5)"
                  class=" btn-link btn tab-link">
            {{ $t('message.perks') }}
          </button>
        </nav>
        <!--        <div class="tab-content form-set personal">-->
        <!--          <div class="server-e pb-0 text-danger" v-if="serverErrors">-->
        <!--            <p class="m-0 pb-1 small d-block" v-for="e in serverErrors">-->
        <!--              {{$t("message."+e)}}-->
        <!--            </p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div v-show="tab === 0" class="tab-content form-set personal">
          <div>
            <ul v-if="personalErrors.length" class=" m-0 pl-3 errors mb-3 mt-2 text-danger">
              <li v-for="m in personalErrors">{{m}}</li>
            </ul>
            <div class="form-row personalia mt-3">
              <div class="col-md-6">
                <label for="firstname">{{ $t('message.first_name') }}<span class="required-field"><i
                  class="fal fa-asterisk"></i></span></label>
                <input :placeholder="$t('message.firstname')"
                       type="text"
                       name="firstname"
                       id="firstname"
                       class="form-control styled-input"
                       v-model="savedUser.firstname">
              </div>
              <div class="col-md-6">
                <label for="lastname">{{ $t('message.last_name') }}<span class="required-field"><i
                  class="fal fa-asterisk"></i></span></label>
                <input :placeholder="$t('message.lastname')"
                       type="text"
                       name="lastname"
                       id="lastname"
                       class="form-control styled-input"
                       v-model="savedUser.lastname">
              </div>
              <div class="col-md-4">
                <label for="birthdate">{{ $t('message.birthdate') }}</label>
                <input :max="today"
                       id="birthdate"
                       name="birthdate"
                       :placeholder="$t('message.birthdate')"
                       type="date"
                       class="form-control styled-input"
                       v-model="savedUser.birthdate">
              </div>
              <div class="col-md-4">
                <label for="gender">{{ $t('message.gender') }}</label>
                <select :placeholder="$t('message.gender')"
                        v-model="savedUser.gender"
                        name="gender"
                        id="gender"
                        class="form-control styled-input">
                  <option selected disabled value="">{{ $t('message.choose') }}</option>
                  <option value="m">{{ $t('message.male') }}</option>
                  <option value="f">{{ $t('message.female') }}</option>
                  <option value="x">{{ $t('message.other') }}</option>
                </select>
                <!--        <input type="text" class="form-control styled-input" v-model="savedUser.gender">-->
              </div>
              <div class="col-md-4">
                <label for="maritalstatus">
                  {{ $t('message.marital_state') }}
                </label>
                <select v-model="savedUser.maritalstatus"
                        name="maritalstatus"
                        id="maritalstatus"
                        class="form-control styled-input">
                  <option selected disabled value="">{{ $t('message.choose') }}</option>
                  <option value="notmarried">{{ $t('message.not_married') }}</option>
                  <option value="married">{{ $t('message.married') }}</option>
                  <option value="divorced">{{ $t('message.divorced') }}</option>
                  <option value="widowed">{{ $t('message.widowed') }}</option>
                </select>
                <!--        <input type="text" class="form-control styled-input" v-model="savedUser.maritalstatus">-->
              </div>
            </div>
            <div class="form-row">
              <div class="col-md-12">
                <label for="degree">{{ $t('message.degree') }}</label>
                <select v-model="savedUser.degreelevel"
                        name="degree" id="degree"
                        class="form-control styled-input">
                  <option value="primary">{{ $t('message.primary') }}</option>
                  <option value="secondary">{{ $t('message.secondary') }}</option>
                  <option value="bachelor">{{ $t('message.bachelor') }}</option>
                  <option value="master">{{ $t('message.master') }}</option>
                  <option value="doctorate">{{ $t('message.doctorate') }}</option>
                </select>
              </div>
              <div class="col-md-12">
                <label for="transport">{{ $t('message.mode_of_transportation') }}</label>
                <select v-model="savedUser.modeoftransport"
                        name="transport"
                        id="transport"
                        class="form-control styled-input">
                  <option value="car">{{ $t('message.car') }}</option>
                  <option value="bike">{{ $t('message.bike') }}</option>
                  <option value="foot">{{ $t('message.foot') }}</option>
                  <option value="public">{{ $t('message.public_transportation') }}</option>
                  <option value="other">{{ $t('message.other') }}</option>
                </select>
              </div>
            </div>
            <div class="form-row mt-4">
              <div class="col-md-12">
                <!--                <div class="text-right" v-show="!editingChild">-->
                <!--                  <button type="button" class="btn btn-link" @click.stop.prevent="editChild(null)">+ {{-->
                <!--                    $t('message.add_child') }}-->
                <!--                  </button>-->
                <!--                </div>-->
                <!--                <transition name="formslide">-->
                <!--                  <form @submit.prevent="saveChild(activeChild.id)" v-show="editingChild" class="childform form-row">-->
                <!--                    <div class="col-md-3">-->
                <!--                      <label for="childname">{{ $t('message.child_name') }}<span class="required-field"><i-->
                <!--                        class="fal fa-asterisk"></i></span></label>-->
                <!--                      <input-->
                <!--                        :placeholder="$t('message.name')"-->
                <!--                        v-model="activeChild.name"-->
                <!--                        required-->
                <!--                        name="childname"-->
                <!--                        id="childname"-->
                <!--                        class="form-control styled-input"-->
                <!--                        type="text">-->
                <!--                    </div>-->
                <!--                    <div class="col-md-3">-->
                <!--                      <label for="childgender">{{ $t('message.gender') }}<span class="required-field"><i-->
                <!--                        class="fal fa-asterisk"></i></span></label>-->
                <!--                      <select v-model="activeChild.gender"-->
                <!--                              required-->
                <!--                              :placeholder="$t('message.gender')"-->
                <!--                              class="form-control styled-input"-->
                <!--                              name="childgender"-->
                <!--                              id="childgender">-->
                <!--                        <option disabled :value="''">{{ $t('message.gender') }}</option>-->
                <!--                        <option value="m">{{ $t('message.male') }}</option>-->
                <!--                        <option value="f">{{ $t('message.female') }}</option>-->
                <!--                      </select>-->
                <!--                    </div>-->
                <!--                    <div class="col-md-3">-->
                <!--                      <label class="mb-1" for="childbirthdate">{{ $t('message.birthdate') }}<span-->
                <!--                        class="required-field"><i-->
                <!--                        class="fal fa-asterisk"></i></span></label>-->
                <!--                      <input v-model="activeChild.birthdate"-->
                <!--                             :max="today"-->
                <!--                             id=childbirthdate-->
                <!--                             name=childbirthdate-->
                <!--                             :placeholder="$t('message.birthdate')"-->
                <!--                             required-->
                <!--                             class="form-control styled-input"-->
                <!--                             type="date">-->
                <!--                    </div>-->
                <!--                    <div class="col-md-3">-->
                <!--                      <label for="infamily" class="">{{ $t('message.in_family') }}<span class="required-field"><i-->
                <!--                        class="fal fa-asterisk"></i></span></label>-->
                <!--                      <select v-model="activeChild.archived"-->
                <!--                              required-->
                <!--                              name="infamily"-->
                <!--                              id="infamily"-->
                <!--                              class="form-control styled-input">-->
                <!--                        <option :value="''" selected disabled>- {{ $t('message.choose_a_status') }} -</option>-->
                <!--                        <option value="false">{{ $t('message.yes') }}</option>-->
                <!--                        <option value="true">{{ $t('message.no') }}</option>-->
                <!--                      </select>-->
                <!--                    </div>-->
                <!--                    <div class="col-auto" v-if="activeChild.id">-->
                <!--                      <button type="submit" class="btn btn-link text-danger pl-0"-->
                <!--                              v-if="!childDeleteConfirmed"-->
                <!--                              @click.prevent="confirmDeleteChild(activeChild.id)">-->
                <!--                        <i class="fas fa-trash-alt"></i> {{$t('message.delete_child') }}-->
                <!--                      </button>-->
                <!--                      <div class="confirmdelete" v-if="childDeleteConfirmed">-->
                <!--                        <button class="btn btn-danger" @click.prevent="deleteChild(activeChild.id)">-->
                <!--                          {{$t('message.delete_child') }}-->
                <!--                        </button>-->
                <!--                        <button class="btn btn-link">{{$t('message.cancel') }}</button>-->
                <!--                      </div>-->
                <!--                    </div>-->
                <!--                    <div class="col text-right">-->
                <!--                      <button type="reset" @click.prevent.stop="closeChildForm" class="btn btn-link">{{-->
                <!--                        $t('message.cancel') }}-->
                <!--                      </button>-->
                <!--                      <button type="submit" class="btn btn-primary">-->
                <!--                        {{$t('message.save') }}-->
                <!--                      </button>-->
                <!--                    </div>-->
                <!--                  </form>-->
                <!--                </transition>-->
                <!--                {{savedUser.children}}-->

                <table class="mt-3 table table-striped"
                       :class="siteTheme === 'darkmode' ? 'table-dark' : ''">
                  <thead>
                  <tr>
                    <th>{{ $t('message.child_name') }}</th>
                    <th>{{ $t('message.gender') }}</th>
                    <th>{{ $t('message.age') }}</th>
                    <th>{{ $t('message.actions') }}</th>
                  </tr>
                  </thead>
                  <tbody>
                  <child class="p-col" v-for="(p,i) in savedUser.children" v-bind:key="p.id"
                         @deleteChild="deleteChildHandler" :index="i"
                         :child="p">
                  </child>
                  <tr>
                    <button @click="savedUser.children.push({})" type="button" class="btn">+
                      {{$t('message.add_child')}}
                    </button>
                  </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
        </div>
        <div v-show="tab === 1" class="tab-content form-set professional">
          <div>
            <ul v-if="professionalErrors.length" class=" m-0 pl-3 errors mb-3 mt-2 text-danger">
              <li v-for="m in professionalErrors">{{m}}</li>
            </ul>
            <div class="row mt-3 mb-4">
              <div class="col-md-12">
                <div class="form-row">
                  <div class="col-md-6">
                    <label for="">{{ $t('message.title') }}</label>
                    <input type="text" class="form-control styled-input" v-model="savedUser.jobtitle">
                  </div>
                  <div class="col-md-6">
                    <label for="seniority">{{ $t('message.seniority') }}</label>
                    <!--                    <input type="text" class="form-control styled-input" v-model="savedUser.seniority">-->
                    <select name="seniority"
                            class="form-control styled-input"
                            v-model="savedUser.seniority"
                            id="seniority">
                      <option selected disabled value="">{{ $t('message.choose') }}</option>
                      <option value="entry">{{$t('message.seniority_entry')}}</option>
                      <option value="mid">{{$t('message.seniority_mid')}}</option>
                      <option value="senior">{{$t('message.seniority_senior')}}</option>
                    </select>
                  </div>


                  <div class="col-md-6">
                    <label for="">{{ $t('message.start_of_employment') }}</label>
                    <input type="date" class="form-control styled-input" v-model="savedUser.employmentstart">


                    <div class="custom-control custom-checkbox">
                      <input v-model="runningContract" type="checkbox" class="custom-control-input p-0"
                             id="customCheck1">
                      <label class="pt-1 custom-control-label employed" for="customCheck1">{{$t('message.employment_active')}}</label>
                    </div>

                  </div>
                  <div class="col-md-6" v-show="!runningContract ||savedUser.employmentend ">
                    <div class="form-row align-items-center">
                      <div class="col">
                        <label class="" for="">{{ $t('message.end_of_employment') }}</label>
                        <input type="date" class="mb-0 form-control styled-input" v-model="savedUser.employmentend">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <div v-show="tab === 2" class="tab-content form-set account">
          <div>
            <ul v-if="accountErrors.length" class=" m-0 pl-3 errors mb-3 mt-2 text-danger">
              <li v-for="m in accountErrors">{{m}}</li>
            </ul>
            <div class="form-row mt-3">
              <div class="col-md-12">
                <label for="">{{ $t('message.email') }}<span class="required-field"><i
                  class="fal fa-asterisk"></i></span></label>
                <input name="email" autocomplete="email" type="email" class="form-control styled-input"
                       v-model="savedUser.email">
              </div>
              <div class="col-md-12" v-if="savedUser.id">
                <label for="">{{ $t('message.change_password') }}</label>
                <!--                <input type="password" class="form-control styled-input" v-model="newPassword">-->
                <input autocomplete="new-password" :type="showPass ? 'text' : 'password'"
                       class="form-control styled-input" @input="setNewPassword">
                <button type="button" class="mb-3 mr-3 togglepassword position-absolute btn btn-link p-0"
                        @click.prevent.stop="showPass = !showPass">
                  <span v-if="!showPass"><i class="fal fa-fw fa-eye"></i></span>
                  <span v-if="showPass"><i class="fal fa-fw fa-eye-slash"></i></span>
                </button>
              </div>

            </div>
            <div class="form-row mb-4">
              <div class="col-md-12" v-if="savedUser.id">
                <label for="">{{ $t('message.confirm_password') }}</label>
                <input autocomplete="confirm-new-password" :type="showPassConfirm ? 'text' : 'password'"
                       class="form-control styled-input" @change="validateNewPassword">
                <button type="button" class="mb-3 mr-3 togglepassword position-absolute btn btn-link p-0"
                        @click.prevent.stop="showPassConfirm = !showPassConfirm">
                  <span v-if="!showPassConfirm"><i class="fal fa-fw fa-eye"></i></span>
                  <span v-if="showPassConfirm"><i class="fal fa-fw fa-eye-slash"></i></span>
                </button>
              </div>
              <div class="col-md-12 mt-3" v-if="passwordErrors.length">
                <ul>
                  <li v-for="e in passwordErrors">{{e}}</li>
                </ul>
              </div>
              <div class="col-md-8" v-if="user.role.name === 'HR'&& type !== 'user'">
                <label for="role">{{ $t('message.role') }}</label>
                <select v-model="savedUser.role.id"
                        name="role"
                        id="role"
                        class="form-control styled-input">
                  <option value="1">{{$t('message.user')}}</option>
                  <option value="3">{{$t('message.hr')}}</option>
                </select>
                <!--                <div class="mt-4 toggler d-flex align-items-center">-->
                <!--                  {{ $t('message.is_finalized') }}-->
                <!--                  <label class=" ml-2 switch">-->
                <!--                    <input id="ufinal" v-model="savedUser.isFinalized" type="checkbox" class="styled-input">-->
                <!--                    <span class="slider round">-->
                <!--                    <div class="w-50 h-100 float-left d-flex align-items-center justify-content-center small">-->
                <!--                    </div>-->
                <!--                    <div class="w-50 h-100 float-right d-flex align-items-center justify-content-center small">-->
                <!--                    </div>-->

                <!--                  </span>-->
                <!--                  </label>-->
                <!--                </div>-->


              </div>
              <div class="col-md-4"
                   v-if="user.role.name === 'HR'&& type !== 'user' && parseInt(user.accesslevel) >= 90">
                <label for="role">{{ $t('message.accesslevel') }}</label>
                <select v-model="savedUser.accesslevel"
                        name="accesslevel"
                        id="accesslevel"
                        class="form-control styled-input">
                  <option v-for="level in accessLevels" :value="level">{{level}}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div v-show="tab === 6" class="tab-content form-set team">
          <div>
            <ul v-if="teamErrors.length" class=" m-0 pl-3 errors mb-3 mt-2 text-danger">
              <li v-for="m in teamErrors">{{m}}</li>
            </ul>
            <div class="form-row mt-3">
              <!--              {{user}}-->
              <div class="mt-2 col-md-12">
                <label for="" class="mb-2">{{ $t('message.add_as_member') }}</label>
                <v-select :placeholder="$t('message.add_team_member') "
                          @input="addMember"
                          class="w-100 styled-input add_member"
                          label="Title"
                          v-model="selected"
                          :options="sortedTeams">

                </v-select>
                <table class="mt-2 table table-striped"
                       :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                  <thead>
                  <tr>
                    <th class="pl-0">{{$t('message.member_of')}}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="team in savedUser.teams">
                    <th>{{team.Title}}</th>
                    <th>
                      <button type="button" @click.prevent="removeMemberFromTeam($event,savedUser.id,team.id)"
                              class="btn btn-link">
                        <i class="far fa-trash-alt"></i> {{$t('message.remove_from_team')}}
                      </button>
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>

              <div class="mt-5 col-md-12">
                <label for="" class="mb-2">{{ $t('message.add_as_manager') }}</label>
                <v-select :placeholder="$t('message.add_team_member') "
                          @input="addManager"
                          class="w-100 styled-input add_member"
                          label="Title"
                          v-model="selected"
                          :options="sortedTeams">

                </v-select>
                <table class="mt-2 table table-striped"
                       :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                  <thead>
                  <tr>
                    <th class="pl-0">{{$t('message.manager_of')}}</th>
                    <th></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="team in savedUser.managesTeams">
                    <th>{{team.Title}}</th>
                    <th>
                      <button type="button" @click.prevent="removeManagerFromTeam($event,savedUser.id,team.id)"
                              class="btn btn-link">
                        <i class="far fa-trash-alt"></i> {{$t('message.remove_from_team')}}
                      </button>
                    </th>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <div class="form-row mb-4">

            </div>
          </div>
        </div>
        <div v-show="tab === 3" class="tab-content form-set contact">
          <div>
            <ul v-if="contactErrors.length" class=" m-0 pl-3 errors mb-3 mt-2 text-danger">
              <li v-for="m in contactErrors">{{m}}</li>
            </ul>
            <div class="form-row mt-3">
              <div class="col-md-8">
                <label for="street">{{ $t('message.street') }}</label>
                <input :placeholder="$t('message.street')"
                       name="street"
                       id="street"
                       type="text"
                       class="form-control styled-input"
                       v-model="savedUser.Street">
              </div>
              <div class="col-md-2">
                <label for="number">{{ $t('message.number') }}</label>
                <input :placeholder="$t('message.number')"
                       name="number"
                       id="number"
                       type="text"
                       class="form-control styled-input"
                       v-model="savedUser.Number">
              </div>
              <div class="col-md-2">
                <label for="bus">{{ $t('message.bus') }}</label>
                <input :placeholder="$t('message.bus')"
                       name="bus"
                       id="bus"
                       type="text"
                       class="form-control styled-input"
                       v-model="savedUser.Bus">
              </div>
              <div class="col-md-4">
                <label for="postalcode">{{ $t('message.zip_postal_code') }}</label>
                <input :placeholder="$t('message.zip_postal_code')"
                       name="postalcode"
                       id="postalcode"
                       type="text"
                       class="form-control styled-input"
                       v-model="savedUser.zipcode">
              </div>
              <div class="col-md-4">
                <label for="city">{{ $t('message.city') }}</label>
                <input :placeholder="$t('message.city')"
                       name="city"
                       id="city"
                       type="text"
                       class="form-control styled-input"
                       v-model="savedUser.city">
              </div>
              <div class="col-md-4">
                <label for="">{{ $t('message.country') }}</label>
                <!--                <input :placeholder="$t('message.country')" type="text" class="form-control styled-input"-->
                <!--                       v-model="savedUser.country">-->
                <select class="form-control styled-input"
                        name="country"
                        id="country"
                        v-model="savedUser.country">
                  <option value="AF">{{$t('message.country_AF')}}</option>
                  <option value="AX">{{$t('message.country_AX')}}</option>
                  <option value="AL">{{$t('message.country_AL')}}</option>
                  <option value="DZ">{{$t('message.country_DZ')}}</option>
                  <option value="AS">{{$t('message.country_AS')}}</option>
                  <option value="AD">{{$t('message.country_AD')}}</option>
                  <option value="AO">{{$t('message.country_AO')}}</option>
                  <option value="AI">{{$t('message.country_AI')}}</option>
                  <option value="AQ">{{$t('message.country_AQ')}}</option>
                  <option value="AG">{{$t('message.country_AG')}}</option>
                  <option value="AR">{{$t('message.country_AR')}}</option>
                  <option value="AM">{{$t('message.country_AM')}}</option>
                  <option value="AW">{{$t('message.country_AW')}}</option>
                  <option value="AU">{{$t('message.country_AU')}}</option>
                  <option value="AT">{{$t('message.country_AT')}}</option>
                  <option value="AZ">{{$t('message.country_AZ')}}</option>
                  <option value="BS">{{$t('message.country_BS')}}</option>
                  <option value="BH">{{$t('message.country_BH')}}</option>
                  <option value="BD">{{$t('message.country_BD')}}</option>
                  <option value="BB">{{$t('message.country_BB')}}</option>
                  <option value="BY">{{$t('message.country_BY')}}</option>
                  <option value="BE">{{$t('message.country_BE')}}</option>
                  <option value="BZ">{{$t('message.country_BZ')}}</option>
                  <option value="BJ">{{$t('message.country_BJ')}}</option>
                  <option value="BM">{{$t('message.country_BM')}}</option>
                  <option value="BT">{{$t('message.country_BT')}}</option>
                  <option value="BO">{{$t('message.country_BO')}}</option>
                  <option value="BQ">{{$t('message.country_BQ')}}</option>
                  <option value="BA">{{$t('message.country_BA')}}</option>
                  <option value="BW">{{$t('message.country_BW')}}</option>
                  <option value="BV">{{$t('message.country_BV')}}</option>
                  <option value="BR">{{$t('message.country_BR')}}</option>
                  <option value="IO">{{$t('message.country_IO')}}</option>
                  <option value="BN">{{$t('message.country_BN')}}</option>
                  <option value="BG">{{$t('message.country_BG')}}</option>
                  <option value="BF">{{$t('message.country_BF')}}</option>
                  <option value="BI">{{$t('message.country_BI')}}</option>
                  <option value="KH">{{$t('message.country_KH')}}</option>
                  <option value="CM">{{$t('message.country_CM')}}</option>
                  <option value="CA">{{$t('message.country_CA')}}</option>
                  <option value="CV">{{$t('message.country_CV')}}</option>
                  <option value="KY">{{$t('message.country_KY')}}</option>
                  <option value="CF">{{$t('message.country_CF')}}</option>
                  <option value="TD">{{$t('message.country_TD')}}</option>
                  <option value="CL">{{$t('message.country_CL')}}</option>
                  <option value="CN">{{$t('message.country_CN')}}</option>
                  <option value="CX">{{$t('message.country_CX')}}</option>
                  <option value="CC">{{$t('message.country_CC')}}</option>
                  <option value="CO">{{$t('message.country_CO')}}</option>
                  <option value="KM">{{$t('message.country_KM')}}</option>
                  <option value="CG">{{$t('message.country_CG')}}</option>
                  <option value="CD">{{$t('message.country_CD')}}</option>
                  <option value="CK">{{$t('message.country_CK')}}</option>
                  <option value="CR">{{$t('message.country_CR')}}</option>
                  <option value="CI">{{$t('message.country_CI')}}</option>
                  <option value="HR">{{$t('message.country_HR')}}</option>
                  <option value="CU">{{$t('message.country_CU')}}</option>
                  <option value="CW">{{$t('message.country_CW')}}</option>
                  <option value="CY">{{$t('message.country_CY')}}</option>
                  <option value="CZ">{{$t('message.country_CZ')}}</option>
                  <option value="DK">{{$t('message.country_DK')}}</option>
                  <option value="DJ">{{$t('message.country_DJ')}}</option>
                  <option value="DM">{{$t('message.country_DM')}}</option>
                  <option value="DO">{{$t('message.country_DO')}}</option>
                  <option value="EC">{{$t('message.country_EC')}}</option>
                  <option value="EG">{{$t('message.country_EG')}}</option>
                  <option value="SV">{{$t('message.country_SV')}}</option>
                  <option value="GQ">{{$t('message.country_GQ')}}</option>
                  <option value="ER">{{$t('message.country_ER')}}</option>
                  <option value="EE">{{$t('message.country_EE')}}</option>
                  <option value="ET">{{$t('message.country_ET')}}</option>
                  <option value="FK">{{$t('message.country_FK')}}</option>
                  <option value="FO">{{$t('message.country_FO')}}</option>
                  <option value="FJ">{{$t('message.country_FJ')}}</option>
                  <option value="FI">{{$t('message.country_FI')}}</option>
                  <option value="FR">{{$t('message.country_FR')}}</option>
                  <option value="GF">{{$t('message.country_GF')}}</option>
                  <option value="PF">{{$t('message.country_PF')}}</option>
                  <option value="TF">{{$t('message.country_TF')}}</option>
                  <option value="GA">{{$t('message.country_GA')}}</option>
                  <option value="GM">{{$t('message.country_GM')}}</option>
                  <option value="GE">{{$t('message.country_GE')}}</option>
                  <option value="DE">{{$t('message.country_DE')}}</option>
                  <option value="GH">{{$t('message.country_GH')}}</option>
                  <option value="GI">{{$t('message.country_GI')}}</option>
                  <option value="GR">{{$t('message.country_GR')}}</option>
                  <option value="GL">{{$t('message.country_GL')}}</option>
                  <option value="GD">{{$t('message.country_GD')}}</option>
                  <option value="GP">{{$t('message.country_GP')}}</option>
                  <option value="GU">{{$t('message.country_GU')}}</option>
                  <option value="GT">{{$t('message.country_GT')}}</option>
                  <option value="GG">{{$t('message.country_GG')}}</option>
                  <option value="GN">{{$t('message.country_GN')}}</option>
                  <option value="GW">{{$t('message.country_GW')}}</option>
                  <option value="GY">{{$t('message.country_GY')}}</option>
                  <option value="HT">{{$t('message.country_HT')}}</option>
                  <option value="HM">{{$t('message.country_HM')}}</option>
                  <option value="VA">{{$t('message.country_VA')}}</option>
                  <option value="HN">{{$t('message.country_HN')}}</option>
                  <option value="HK">{{$t('message.country_HK')}}</option>
                  <option value="HU">{{$t('message.country_HU')}}</option>
                  <option value="IS">{{$t('message.country_IS')}}</option>
                  <option value="IN">{{$t('message.country_IN')}}</option>
                  <option value="ID">{{$t('message.country_ID')}}</option>
                  <option value="IR">{{$t('message.country_IR')}}</option>
                  <option value="IQ">{{$t('message.country_IQ')}}</option>
                  <option value="IE">{{$t('message.country_IE')}}</option>
                  <option value="IM">{{$t('message.country_IM')}}</option>
                  <option value="IL">{{$t('message.country_IL')}}</option>
                  <option value="IT">{{$t('message.country_IT')}}</option>
                  <option value="JM">{{$t('message.country_JM')}}</option>
                  <option value="JP">{{$t('message.country_JP')}}</option>
                  <option value="JE">{{$t('message.country_JE')}}</option>
                  <option value="JO">{{$t('message.country_JO')}}</option>
                  <option value="KZ">{{$t('message.country_KZ')}}</option>
                  <option value="KE">{{$t('message.country_KE')}}</option>
                  <option value="KI">{{$t('message.country_KI')}}</option>
                  <option value="KP">{{$t('message.country_KP')}}</option>
                  <option value="KR">{{$t('message.country_KR')}}</option>
                  <option value="KW">{{$t('message.country_KW')}}</option>
                  <option value="KG">{{$t('message.country_KG')}}</option>
                  <option value="LA">{{$t('message.country_LA')}}</option>
                  <option value="LV">{{$t('message.country_LV')}}</option>
                  <option value="LB">{{$t('message.country_LB')}}</option>
                  <option value="LS">{{$t('message.country_LS')}}</option>
                  <option value="LR">{{$t('message.country_LR')}}</option>
                  <option value="LY">{{$t('message.country_LY')}}</option>
                  <option value="LI">{{$t('message.country_LI')}}</option>
                  <option value="LT">{{$t('message.country_LT')}}</option>
                  <option value="LU">{{$t('message.country_LU')}}</option>
                  <option value="MO">{{$t('message.country_MO')}}</option>
                  <option value="MK">{{$t('message.country_MK')}}</option>
                  <option value="MG">{{$t('message.country_MG')}}</option>
                  <option value="MW">{{$t('message.country_MW')}}</option>
                  <option value="MY">{{$t('message.country_MY')}}</option>
                  <option value="MV">{{$t('message.country_MV')}}</option>
                  <option value="ML">{{$t('message.country_ML')}}</option>
                  <option value="MT">{{$t('message.country_MT')}}</option>
                  <option value="MH">{{$t('message.country_MH')}}</option>
                  <option value="MQ">{{$t('message.country_MQ')}}</option>
                  <option value="MR">{{$t('message.country_MR')}}</option>
                  <option value="MU">{{$t('message.country_MU')}}</option>
                  <option value="YT">{{$t('message.country_YT')}}</option>
                  <option value="MX">{{$t('message.country_MX')}}</option>
                  <option value="FM">{{$t('message.country_FM')}}</option>
                  <option value="MD">{{$t('message.country_MD')}}</option>
                  <option value="MC">{{$t('message.country_MC')}}</option>
                  <option value="MN">{{$t('message.country_MN')}}</option>
                  <option value="ME">{{$t('message.country_ME')}}</option>
                  <option value="MS">{{$t('message.country_MS')}}</option>
                  <option value="MA">{{$t('message.country_MA')}}</option>
                  <option value="MZ">{{$t('message.country_MZ')}}</option>
                  <option value="MM">{{$t('message.country_MM')}}</option>
                  <option value="NA">{{$t('message.country_NA')}}</option>
                  <option value="NR">{{$t('message.country_NR')}}</option>
                  <option value="NP">{{$t('message.country_NP')}}</option>
                  <option value="NL">{{$t('message.country_NL')}}</option>
                  <option value="NC">{{$t('message.country_NC')}}</option>
                  <option value="NZ">{{$t('message.country_NZ')}}</option>
                  <option value="NI">{{$t('message.country_NI')}}</option>
                  <option value="NE">{{$t('message.country_NE')}}</option>
                  <option value="NG">{{$t('message.country_NG')}}</option>
                  <option value="NU">{{$t('message.country_NU')}}</option>
                  <option value="NF">{{$t('message.country_NF')}}</option>
                  <option value="MP">{{$t('message.country_MP')}}</option>
                  <option value="NO">{{$t('message.country_NO')}}</option>
                  <option value="OM">{{$t('message.country_OM')}}</option>
                  <option value="PK">{{$t('message.country_PK')}}</option>
                  <option value="PW">{{$t('message.country_PW')}}</option>
                  <option value="PS">{{$t('message.country_PS')}}</option>
                  <option value="PA">{{$t('message.country_PA')}}</option>
                  <option value="PG">{{$t('message.country_PG')}}</option>
                  <option value="PY">{{$t('message.country_PY')}}</option>
                  <option value="PE">{{$t('message.country_PE')}}</option>
                  <option value="PH">{{$t('message.country_PH')}}</option>
                  <option value="PN">{{$t('message.country_PN')}}</option>
                  <option value="PL">{{$t('message.country_PL')}}</option>
                  <option value="PT">{{$t('message.country_PT')}}</option>
                  <option value="PR">{{$t('message.country_PR')}}</option>
                  <option value="QA">{{$t('message.country_QA')}}</option>
                  <option value="RE">{{$t('message.country_RE')}}</option>
                  <option value="RO">{{$t('message.country_RO')}}</option>
                  <option value="RU">{{$t('message.country_RU')}}</option>
                  <option value="RW">{{$t('message.country_RW')}}</option>
                  <option value="BL">{{$t('message.country_BL')}}</option>
                  <option value="SH">{{$t('message.country_SH')}}</option>
                  <option value="KN">{{$t('message.country_KN')}}</option>
                  <option value="LC">{{$t('message.country_LC')}}</option>
                  <option value="MF">{{$t('message.country_MF')}}</option>
                  <option value="PM">{{$t('message.country_PM')}}</option>
                  <option value="VC">{{$t('message.country_VC')}}</option>
                  <option value="WS">{{$t('message.country_WS')}}</option>
                  <option value="SM">{{$t('message.country_SM')}}</option>
                  <option value="ST">{{$t('message.country_ST')}}</option>
                  <option value="SA">{{$t('message.country_SA')}}</option>
                  <option value="SN">{{$t('message.country_SN')}}</option>
                  <option value="RS">{{$t('message.country_RS')}}</option>
                  <option value="SC">{{$t('message.country_SC')}}</option>
                  <option value="SL">{{$t('message.country_SL')}}</option>
                  <option value="SG">{{$t('message.country_SG')}}</option>
                  <option value="SX">{{$t('message.country_SX')}}</option>
                  <option value="SK">{{$t('message.country_SK')}}</option>
                  <option value="SI">{{$t('message.country_SI')}}</option>
                  <option value="SB">{{$t('message.country_SB')}}</option>
                  <option value="SO">{{$t('message.country_SO')}}</option>
                  <option value="ZA">{{$t('message.country_ZA')}}</option>
                  <option value="GS">{{$t('message.country_GS')}}</option>
                  <option value="SS">{{$t('message.country_SS')}}</option>
                  <option value="ES">{{$t('message.country_ES')}}</option>
                  <option value="LK">{{$t('message.country_LK')}}</option>
                  <option value="SD">{{$t('message.country_SD')}}</option>
                  <option value="SR">{{$t('message.country_SR')}}</option>
                  <option value="SJ">{{$t('message.country_SJ')}}</option>
                  <option value="SZ">{{$t('message.country_SZ')}}</option>
                  <option value="SE">{{$t('message.country_SE')}}</option>
                  <option value="CH">{{$t('message.country_CH')}}</option>
                  <option value="SY">{{$t('message.country_SY')}}</option>
                  <option value="TW">{{$t('message.country_TW')}}</option>
                  <option value="TJ">{{$t('message.country_TJ')}}</option>
                  <option value="TZ">{{$t('message.country_TZ')}}</option>
                  <option value="TH">{{$t('message.country_TH')}}</option>
                  <option value="TL">{{$t('message.country_TL')}}</option>
                  <option value="TG">{{$t('message.country_TG')}}</option>
                  <option value="TK">{{$t('message.country_TK')}}</option>
                  <option value="TO">{{$t('message.country_TO')}}</option>
                  <option value="TT">{{$t('message.country_TT')}}</option>
                  <option value="TN">{{$t('message.country_TN')}}</option>
                  <option value="TR">{{$t('message.country_TR')}}</option>
                  <option value="TM">{{$t('message.country_TM')}}</option>
                  <option value="TC">{{$t('message.country_TC')}}</option>
                  <option value="TV">{{$t('message.country_TV')}}</option>
                  <option value="UG">{{$t('message.country_UG')}}</option>
                  <option value="UA">{{$t('message.country_UA')}}</option>
                  <option value="AE">{{$t('message.country_AE')}}</option>
                  <option value="GB">{{$t('message.country_GB')}}</option>
                  <option value="US">{{$t('message.country_US')}}</option>
                  <option value="UM">{{$t('message.country_UM')}}</option>
                  <option value="UY">{{$t('message.country_UY')}}</option>
                  <option value="UZ">{{$t('message.country_UZ')}}</option>
                  <option value="VU">{{$t('message.country_VU')}}</option>
                  <option value="VE">{{$t('message.country_VE')}}</option>
                  <option value="VN">{{$t('message.country_VN')}}</option>
                  <option value="VG">{{$t('message.country_VG')}}</option>
                  <option value="VI">{{$t('message.country_VI')}}</option>
                  <option value="WF">{{$t('message.country_WF')}}</option>
                  <option value="EH">{{$t('message.country_EH')}}</option>
                  <option value="YE">{{$t('message.country_YE')}}</option>
                  <option value="ZM">{{$t('message.country_ZM')}}</option>
                  <option value="ZW">{{$t('message.country_ZW')}}</option>
                </select>


              </div>
            </div>
          </div>
        </div>
        <div v-show="tab === 4" class="tab-content form-set tags">
          <div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-row">
                  <div class="col-md-12">
                    <select @change="addTag"
                            name="tags"
                            id="tags"
                            class="form-control styled-input">
                      <option value="">{{ $t('message.select_to_add_a_tag') }}</option>
                      <template v-for="p in alltags">
                        <option v-if="!usertags.includes(p.id)" :value="p.id">{{p.description}}</option>
                      </template>
                    </select>
                    <table v-if="savedUser.tags" class="table table-striped"
                           :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                      <thead>
                      <tr>
                        <th>{{ $t('message.tag') }}</th>
                        <th>{{ $t('message.description') }}</th>
                        <th>{{ $t('message.actions') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                        :data-id="perk.id"
                        class=" tag-item"
                        v-for="perk in savedUser.tags">
                        <td class=" name">{{perk.description}}</td>
                        <td>{{perk.title}}</td>
                        <td class=" actions">
                          <button type="button" @click.prevent.stop="removeTag(perk.id)" class="btn-link btn p-0">
                            <i class="far fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-show="tab === 5" class="tab-content form-set perks">
          <div>
            <div class="form-row">
              <div class="col-md-12">
                <div class="form-row">
                  <div class="col-md-12">
                    <!--                    <label for="">Perks</label>-->
                    <select @change="addPerk"
                            name="perks"
                            id="perks"
                            class="form-control styled-input">
                      <option value="">{{ $t('message.select_to_add_a_perk') }}</option>
                      <template v-for="p in allperks">
                        <option v-if="!userperks.includes(p.id)" :value="p.id">{{p.title}}</option>
                      </template>
                    </select>
                    <table v-if="savedUser.perks" class="table table-striped"
                           :class="store.getters.getTheme === 'darkmode' ? 'table-dark' : ''">
                      <thead>
                      <tr>
                        <th>{{ $t('message.perk') }}</th>
                        <th>{{ $t('message.description') }}</th>
                        <th>{{ $t('message.actions') }}</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr
                        :data-id="perk.id"
                        class=" tag-item"
                        v-for="perk in savedUser.perks">
                        <td class=" name">{{perk.title}}</td>
                        <td>{{perk.description}}</td>
                        <td class=" actions">
                          <button type="button" @click.prevent.stop="removePerk(perk.id)" class="btn-link btn p-0">
                            <i class="far fa-trash-alt"></i>
                          </button>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div class="form-row mt-3">
      <div v-if="savedUser.id && savedUser.id !== user.id" class="col text-left row m-0">
        <button type="button" v-if="!showConfirmation" @click.prevent.stop="showConfirmation = true"
                class="pl-0 text-danger btn btn-link btn-form">
          {{$t('message.delete_user')}}
        </button>
        <form class="flex-wrap d-flex" v-if="showConfirmation">
          <input v-model="deleteConfirmation"
                 class="flex-grow-1 w-auto  m-0 form-control styled-input"
                 :placeholder="$t('message.type_delete_to_confirm')" type="text">
          <!--            <button class="btn btn-danger">Delete</button>-->
          <button :disabled="!deleteConfirmed" :class="deleteConfirmed ? '' : 'disabled'"
                  @click.prevent.stop="deleteUser($event,savedUser.id)"
                  type="button"
                  class="flex-shrink-0 btn btn-form ml-2 btn-danger">
            {{$t('message.delete_user')}}
          </button>
          <button type="button" @click.prevent.stop="showConfirmation = false" class="flex-shrink-0 btn btn-link">
            {{$t('message.cancel')}}
          </button>
          <p class="m-0  text-danger small mt-2 w-100 flex-shrink-0">
            {{$t('message.warning_this_cannot_be_undone')}}</p>
        </form>

      </div>
      <template v-if="type !== 'register'">
        <div class="col-md-4 ml-auto text-right">
          <button type="button" v-if="type !== 'user'" @click.prevent="cancelSaveUser" class="btn-link btn">
            {{ $t('message.close') }}
          </button>
          <button type="submit" class="btn button btn-primary save-user-btn">{{ $t('message.save_user') }}</button>
          <!--          <input type="submit" class="btn button btn-primary save-user-btn" :value="$t('message.save_user')">-->
        </div>
      </template>
      <template v-else>
        <div class="col-md-4 ml-auto text-right">
          <button type="submit" class="btn button btn-primary save-user-btn" @click.prevent="submitForm">
            {{ $t('message.register') }}
          </button>
        </div>
      </template>
    </div>


  </form>
</template>

<script>


  // import axios from '../../axios-auth'
  import store from '../../store/store';
  import moment from 'moment'
  import Child from './Child'

  export default {
    components: {
      Child
    },
    computed: {

      sortedTeams() {
        let teams = this.allteams
        teams = _.sortBy(teams, [team => team.Title.toLowerCase()]);
        return teams
      },
      accessLevels() {
        let levels = [];
        let levelCount = 9;

        for (let i = 1; i <= levelCount; i++) {
          levels.push(10 * i)
        }
        return levels;
      },
      today() {
        return moment().format('YYYY-MM-DD')
      },
      siteTheme() {
        return store.getters.theme === 'lightmode';
      },
    },
    data() {
      return {
        selected: null,
        serverErrors: null,
        showPass: false,
        showPassConfirm: false,
        selectedMemberTeam: null,
        selectedManagerTeam: null,
        deleteConfirmation: '',
        deleteConfirmed: false,
        showConfirmation: false,
        runningContract: true,
        store,
        user: null,
        passwordErrors: [],
        newValidPassword: null,
        newPassword: '',
        editingChild: false,
        activeChild: {name: '', gender: '', birthdate: null, archived: ''},
        originalChild: {name: '', gender: '', birthdate: null},
        tab: 0,
        userTeams: [],
        userManageTeams: [],
        allperks: [],
        userperks: [],
        allteams: [],
        alltags: [],
        usertags: [],
        savedUser: {role: {id: 1}},
        personalErrors: [],
        professionalErrors: [],
        accountErrors: [],
        contactErrors: [],
        teamErrors: [],
        originalUser: null,
        toDeleteChildren: [],
        childDeleteConfirmed: false,
        teamlist: []
      }
    },
    watch: {
      deleteConfirmation() {
        if (this.deleteConfirmation === 'DELETE') {
          this.deleteConfirmed = true;
        } else {
          this.deleteConfirmed = false;
        }
      }
    },
    methods: {
      deleteChildHandler(i) {
      //  console.log('i', i)
        let children = this.savedUser.children;
      //  console.log('chidlren', children);
        children = children.splice(i, 1);
      //  console.log('chidlren', children)
      },
      setNewPassword(e) {
        this.newPassword = e.target.value;
      },
      addMember(t) {
        let t_id = t.id;
        let already_member = false;
        if (!this.savedUser.teams) {
          this.savedUser.teams = []
        }
        this.savedUser.teams.forEach((team, index) => {
          if (team.id === t_id) {
            already_member = true;
          }
        });
        if (!already_member) {
          this.savedUser.teams.push(t);
        }
        this.selected = null
      },
      addManager(t) {
        let t_id = t.id;
        let already_manager = false;
        if (!this.savedUser.managesTeams) {
          this.savedUser.managesTeams = []
        }
        this.savedUser.managesTeams.forEach((team, index) => {
          if (team.id === t_id) {
            already_manager = true;
          }
        });
        if (!already_manager) {
          this.savedUser.managesTeams.push(t);
        }
        this.selected = null
      },
      removeMemberFromTeam(evt, uid, t_id) {
        this.savedUser.teams.forEach((team, ind) => {
      //    console.log('t_id', t_id, team.id)

          if (parseInt(team.id) === parseInt(t_id)) {
         //   console.log('found team', ind);
            // this.$set(this.savedUser,'teams',this.savedUser.teams.splice(ind, 1))
            this.savedUser.teams.splice(ind, 1);
            this.$set(this.savedUser, 'teams', this.savedUser.teams)
          }
        });
        this.logActivity('Removed team member', 'info (HR)');
      },
      removeManagerFromTeam(evt, uid, t_id) {
        this.savedUser.managesTeams.forEach((team, ind) => {
          if (parseInt(team.id) === parseInt(t_id)) {
            // this.savedUser.managesTeams.splice(ind, 1);
            this.savedUser.managesTeams.splice(ind, 1);
            this.$set(this.savedUser, 'managesTeams', this.savedUser.managesTeams)
          }
        });
        this.logActivity('Removed team member', 'info (HR)');
      },
      deleteUser(e, uid) {
        if (this.deleteConfirmed) {
          const el = e.target;

          el.classList.add('loading');
          this.axios.delete('/users/' + uid,).then(res => {

            this.loadingSuccess(el);
            this.closePopup();
            //   console.log(res)
            const logWrite = this.logActivity('Deleted user', 'info (HR)').then(r => {
              // console.log('emitting saved', logWrite)
              // console.log('log', r)
              // this.$emit('saved', logWrite)
            });
            // console.log('emitting saved');
            this.$emit('saved')
          })
        }
      },
      validatePersonal() {
        this.personalErrors = [];
        // console.log('validating personal', this.savedUser);
        let valid = true;
        const requiredKeys = ['firstname', 'lastname'];
        requiredKeys.forEach((val, ind) => {
          //  console.log('validating', val)
          if (!(val in this.savedUser) || this.savedUser[val].length < 1) {
            //  console.log('invalid', val)
            this.personalErrors.push(this.$t('message.' + val) + ' ' + this.$t('message.cannot_be_empty'));
            valid = false;
          }
        });
        return valid;
      },
      validateProfessional() {
        this.professionalErrors = [];
        // console.log('validating professional', this.savedUser);
        let valid = true;
        return valid;
      },
      validateAccount() {
        // this.accountErrors = [];
      //  console.log('validating account', this.savedUser);
        let valid = true;
        const requiredKeys = ['email'];
        requiredKeys.forEach((val, ind) => {
          if (!(val in this.savedUser) || this.savedUser[val].length < 1) {
            this.accountErrors.push(this.$t('message.' + val) + ' ' + this.$t('message.cannot_be_empty'));
            valid = false;
          }
        });
        return valid;
      },
      validateContact() {
        this.contactErrors = [];
        //  console.log('validating contact', this.savedUser);
        let valid = true;

        const alphanumKeys = [
          'Street',
          'Number',
          'Bus',
          'zipcode',
          'city',
        ];
        alphanumKeys.forEach((val, ind) => {
          if (this.savedUser[val] && !this.validateAlphanumeric(this.savedUser[val])) {
            valid = false;
            this.contactErrors.push(this.$t('message.' + val) + ' ' + this.$t('message.must_be_alphanumeric'));
          }
        });

        return valid;
      },
      validateForm() {
        this.errors = [];
        let valid = true;
        //  console.log('validating user', this.savedUser);
        const validatePersonal = this.validatePersonal()
        const validateProfessional = this.validateProfessional()
        const validateAccount = this.validateAccount()
        const validateContact = this.validateContact()
        //   console.log('validations', [validatePersonal,
        //     validateProfessional,
        //     validateAccount,
        //      validateContact])
        if (
          !validatePersonal ||
          !validateProfessional ||
          !validateAccount ||
          !validateContact
        ) {
          valid = false
        }
        //   console.log('validation done, result', valid)
        return valid;
      },
      changesHappened() {
        return !(this.userObj === this.savedUser);
      },
      validateNewPassword(e) {
        this.passwordErrors = [];
        let valid = true;
        let val = e.target.value;
        if (this.newPassword.length < 6) {
          valid = false;
          this.passwordErrors.push(this.$t('message.password_min_6_long'))
        }
        if (this.newPassword !== val) {
          valid = false;
          this.passwordErrors.push(this.$t('message.passwords_no_match'))
        }
        if (valid) {
          this.newValidPassword = this.newPassword;
        }
      },
      setTab(i) {
        this.tab = i;
      },
      removeTag(id) {
        this.usertags.forEach((val, ind) => {
          if (val === id) {
            this.usertags.splice(ind, 1)
          }
        });
        this.userObj.tags.forEach((val, ind) => {
          if (val.id === id) {
            this.userObj.tags.splice(ind, 1)
          }
        });
      },
      removePerk(id) {
        this.userperks.forEach((val, ind) => {
          if (val === id) {
            this.userperks.splice(ind, 1)
          }
        });
        this.userObj.perks.forEach((val, ind) => {
          if (val.id === id) {
            this.userObj.perks.splice(ind, 1)
          }
        });
      },
      clearChildForm() {
        this.activeChild = {
          name: '',
          birthdate: '',
          gender: '',
          archived: ''
        };
        const el = document.querySelector('#childbirthdate');
        // console.log('clearing child form',el)
        el._flatpickr.clear()
      },
      closeChildForm() {
        this.clearChildForm();
        this.editingChild = false;
      },
      randomPassword(length = 12) {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
        let pwa = [];
        for (let i = 0; i < length; i++) {
          let char = chars.charAt(Math.round(Math.random() * (chars.length - 1)));
          pwa.push(char);
        }
        let pws = pwa.join('');
        return pws;
      },
      saveChild(id = null) {
        if (moment(this.activeChild.birthdate) > moment(this.today)) {
          //   console.log('age impossible');
          this.activeChild = this.originalChild;
          if (id !== null) {
            let ep = '';
            if (this.type === 'user') {
              ep = '/users/me'
            } else {
              ep = 'users/' + this.userObj.id
            }
            this.axios.get(ep).then(res => {
              //   console.log('refetch children',res.data.children)
              this.savedUser.children = res.data.children
            });

          }
        } else {
          if (id !== null) {
            this.axios.put('/children/' + id, this.activeChild).then(res => {
              this.logActivity('Edited child', 'info');
              const child = res.data;
            })
          } else {
            this.axios.post('/children', this.activeChild).then(res => {
              this.logActivity('Added child', 'info');
              const child = res.data;
              this.savedUser.children.push(child);
            })
          }
          this.closeChildForm()
        }
      },
      editChild(child) {
        if (child == null) {
          // child = {};
          this.clearChildForm()
        }
        // this.activeChild = child;
        this.editingChild = true;
      },
      confirmDeleteChild() {
        this.childDeleteConfirmed = true
      },
      deleteChild(child_id) {
        this.closeChildForm();
        this.savedUser.children.forEach((child, index) => {
          if (child == child_id || child.id == child_id) {
            this.savedUser.children.splice(index, 1);
          }
        });
      },
      addTag(e) { //todo if picked, hide option from options list
        let tag_id = e.target.value;
        if (!this.usertags.includes(tag_id) && tag_id) {
          this.usertags.push(tag_id)
          this.savedUser.tags.push({id: tag_id, description: e.target.selectedOptions[0].innerText})
        }
        e.target.selectedIndex = 0

      },
      addPerk(e) { //todo if picked, hide option from options list
        let perk_id = e.target.value;
        if (!this.userperks.includes(perk_id) && perk_id) {
          this.userperks.push(perk_id)
          this.savedUser.perks.push({id: perk_id, title: e.target.selectedOptions[0].innerText})
        }
        e.target.selectedIndex = 0

      },
      resetValues() {
        this.savedUser = {role: {id: 1}};
        this.savedUser = this.originalUser
      },
      closePopup(reload = false) {
        this.$emit('closePopup', reload)
      },
      checkTeams() {
        if (this.savedUser.teams) {
          this.savedUser.teams.forEach((val, ind) => {
            this.userTeams.push(val.id);
          });
        }
        if (this.savedUser.managesTeams) {
          this.savedUser.managesTeams.forEach((val, ind) => {
            this.userManageTeams.push(val.id);
          });
        }
      },
      submitForm(e) {
        let el = document.querySelector('.save-user-btn');
      //  console.log('el', el)
        el.classList.add('loading');
        const valid = this.validateForm();
        if (valid) {
          if (this.type !== 'user') {
            this.savedUser.role = this.savedUser.role.id;
          }
          this.saveUser(e)
        } else {
          this.loadingSuccess(el);
          // el.classList.remove('loading');
        }
      },
      cancelSaveUser() {
        this.resetValues();
        this.closePopup(true)
      },
      async createUser(e, user) {
        // let el = e.target;
        let el = document.querySelector('.save-user-btn');
        user.password = this.randomPassword();
        return await this.axios.post('/users', user).then(res => {
          this.$emit('saved');
          this.logActivity('Created user', 'info (HR)');
          this.closePopup(true);
          this.$emit('reload');
          this.loadingSuccess(el);
          this.mailPass(user);
          this.logActivity('Edited user', 'info (HR)')
          return res
        }).catch(r => {
          el.classList.remove('loading');
          let errorMessages = r.response.data.message[0].messages;
          errorMessages.forEach(e => {
            let msg = 'misc_server_error';
            if (
              e.id === 'Auth.form.error.email.taken' ||
              e.id === 'Auth.form.error.username.taken'
            ) {
              msg = 'emailtaken_server_error'
            }
            this.accountErrors.push(this.$t('message.' + msg))
          })
        })
      },
      mailPass(user) {
        // console.log('mailing pass to', user);
        this.sendPasswordMail(
          user.email,
          'info@workvitamins.org',
          'Your Vitamins account has been created',
          'Your login is: ' + user.email + '<br />' +
          'Your password is: ' + user.password
        ).then(r => {
          // console.log('password mail sent', r, user)
        }).catch(r => {
          // console.log('error sending mail', (r))
        })
      },
      async editUser(e, user) {
      //  console.log('user obj on edit', user)
        delete user.submissions
     //   console.log('user obj on edit', user)
        let role = 'HR';
        let ep = '/users/' + this.userObj.id;
        if (this.type === 'user') {
          role = 'User';
          ep = '/users/me'
        }
        if (this.newValidPassword) {
          user.password = this.newValidPassword;
        }
        return await this.axios.put(ep, user).then(res => {
          return res
        })
      },
      saveUser(e) {
        let el = document.querySelector('.save-user-btn');

        let role = 'HR';
        if (this.type === 'user') {
          role = 'User';
        }
        this.savedUser.username = this.savedUser.email;
        this.savedUser.fullname = this.savedUser.firstname + ' ' + this.savedUser.lastname;
        const saveData = JSON.parse(JSON.stringify(this.savedUser));
        saveData.tags = this.usertags;
        saveData.perks = this.userperks;
        if (this.savedUser.id) {
          this.editUser(e, saveData).then(r => {
            this.saveChildren().then(savedResponse => {
              const children = [];
              savedResponse.forEach(childResponse => {
                children.push(childResponse.data)
              });
              let call = '';
              if (this.type === 'user') {
                call = '/users/me';
              }else{
                call = '/users/' + r.data.id
              }
              this.axios.put(call, {children: children}).then(saved => {
                this.$emit('reload');
                this.logActivity('Edited user', 'info (' + role + ')');
                if (this.type === 'user') {
                  store.dispatch('setUser', this.savedUser)
                } else {
                  this.closePopup(true);
                }
                this.loadingSuccess(el);
                // console.log('saved children to user', saved, children)
              })
            })
          });
        } else {
          this.createUser(e, saveData).then(r => {
           // console.log('user call response', r);
            this.saveChildren().then(savedResponse => {
              const children = []
              savedResponse.forEach(childResponse => {
                children.push(childResponse.data)
              });
              this.axios.put('/users/' + r.data.id, {children: children}).then(saved => {
               // console.log('saved children to user', saved, children)
              })
            })
          })
        }

      },
      async saveChildren() {

        let promises = this.savedUser.children.map((child, resultIndex) => {
          let call = null;
          if (child.id) {
            call = this.axios.put('/children/' + child.id, child)
          } else {
            call = this.axios.post('/children', child)
          }
          return call
        });
        const done = Promise.all(promises);
       // console.log('promises done', done)
        return done
      }
    },

    mounted() {
      if (this.type === 'user') {
        this.savedUser = store.getters.getUser;
      } else {
        this.savedUser = this.userObj;
      }

      this.savedUser = this.userObj;
      this.originalUser = JSON.parse(JSON.stringify(this.userObj));
    },
    created() {

      this.user = store.getters.getUser;
      this.axios.get('/perks').then(res => {
        this.allperks = res.data
      });

      this.axios.get('/tags').then(res => {
        this.alltags = res.data
      });

      this.axios.get('/teams/teamlist?status=1&_limit=-1').then(res => {
        this.allteams = res.data
        // this.sortTeams()
      });

      if (typeof this.userObj.perks !== 'undefined') {
        this.userObj.perks.forEach((val, ind) => {
          this.userperks.push(val.id)
        });
      }

      if (typeof this.userObj.tags !== 'undefined') {
        this.userObj.tags.forEach((val, ind) => {
          this.usertags.push(val.id)
        });
      }
      //   console.log('user', this.userObj)
      this.checkTeams()
    },
    props: {
      type: {
        type: String,
        default() {
          return 'edit' //other option is 'register'
        }
      },
      userObj: {
        type: Object,
        default() {
          return {
            // role: {name: ''},
            perks: [],
            tags: [],
            children: []
          }
        }
      }

    }
  }
</script>
<style scoped>


  .formslide-enter-active {
    animation: form-in .6s ease-out forwards;
  }

  .formslide-leave-active {
    animation: form-out .3s ease-out forwards;
  }

  @keyframes form-in {
    from {
      opacity: 0;
      max-height: 0px;
      /*transform: scaleY(0);*/
    }
    to {
      opacity: 1;
      max-height: 500px;
      /*transform: scaleY(1);*/
    }
  }

  @keyframes form-out {
    from {
      opacity: 1;
      max-height: 500px;
      /*transform: scaleY(1);*/
    }
    to {
      opacity: 0;
      max-height: 0px;
      /*transform: scaleY(0);*/
    }
  }


  form label {
    text-transform: uppercase;
    font-weight: bold;
  }

  .child-actions {
    width: 250px;
  }

  .lightmode .confirm-delete-child {
    background-color: #ececec;
  }

  .confirm-delete-child {
    position: absolute;
    left: 0;
    top: 0;
    background-color: #3e444a;
    width: 100%;
    height: 100%;
    padding: 10px;
  }

  .employed {
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/Users/Userform.vue